export const IPIRANGA_PROMOTION_AVAILABLE = 'IPIRANGA_PROMOTION_AVAILABLE'
export const IPIRANGA_PROMOTION_RESET = 'IPIRANGA_PROMOTION_RESET'
